/**
 * @file: AiCreditAlertState.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum AiCreditAlertState {
  Normal = 'normal',
  Low = 'low',
  Exhausted = 'exhausted',
}

export const AiCreditAlertStateValueSet = new Set([
  AiCreditAlertState.Normal,
  AiCreditAlertState.Low,
  AiCreditAlertState.Exhausted,
]);
